import React from 'react';
import ResponsiveImage from './ResponsiveImage';

const RenderImage = ({ item, isEditMode, howManyColumns, fetchPriority }) => {
  if (!item.image_field) return null;

  return (
    <ResponsiveImage
      item={item}
      howManyColumns={howManyColumns}
      fetchPriority={fetchPriority}
    />
  );
};

export default RenderImage;
